module.exports = __webpack_public_path__ + "media/images/athletes/1755-f147be529ba7fd5c9ae382142dee1138.png";